// extracted by mini-css-extract-plugin
export var axisLabel = "Histogram-module--axisLabel--1afec";
export var caption = "Histogram-module--caption--618ba";
export var container = "Histogram-module--container--d3f77";
export var svg = "Histogram-module--svg--efa63";